import { AppSidebar } from '@/components/shared/AppSidebar';
import { LoadingScreen } from '@/components/shared/LoadingScreen';
import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useFacebookToken } from '@/hooks/useFacebookToken';
import { useTeamStatus } from '@/hooks/useTeamStatus';
import { AlertCircle } from 'lucide-react';
import { Outlet } from 'react-router-dom';

export const AuthLayout = () => {
  const { needsReauthentication, authenticate } = useFacebookToken();
  const { teamSocialsConnected, isInitalising } = useTeamStatus();

  if (isInitalising) {
    return <LoadingScreen message="Loading..." />;
  }

  return (
    <TooltipProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="flex flex-col flex-1">
          <header className="shrink-0 h-16 mt-3">
            <div className="flex items-center gap-2 px-8 h-full">
              <SidebarTrigger className="-ml-0.5 border-0" />
              {needsReauthentication && teamSocialsConnected && (
                <Alert
                  variant="destructive"
                  className="ml-4 flex items-center gap-4 py-1.5 pr-4 text-sm">
                  <AlertCircle className="h-4 w-4 shrink-0" />
                  <p className="flex-1">
                    Your Facebook token has expired. Please log back in
                  </p>
                  <div>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => authenticate.mutate()}
                      disabled={authenticate.isPending}
                      isLoading={authenticate.isPending}>
                      Reauthenticate
                    </Button>
                  </div>
                </Alert>
              )}
            </div>
          </header>
          <div className="flex-1 min-h-0 flex flex-col h-full p-8 pt-3 gap-4 w-full">
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
};
